const variantPersonalizationValues = {};

function handleVariantChange(event) {
  const variantId = event.detail.variant.id;
  handlePersonalizeFocus();
  handlePersonalizationVisibility(variantId);
  handleBadgeVisibility(variantId);
  handleBatchVisibility(variantId);
}

function handlePersonalizationVisibility(variantId) {
    if (!document.querySelector('[data-personalization-for]')) return;

  const visible = document.querySelector('[data-personalization-variant-id]:not(.hidden)')
  if (visible) {
    visible.classList.add('hidden');
    let variantValueInput = visible.querySelector('[data-action="handle-personalization"]')
    if (variantValueInput) {
      let variantInputValue = variantValueInput.value;
      if (variantInputValue.trim() !== '') {
        variantPersonalizationValues[visible.getAttribute('data-personalization-for')] = variantInputValue;
      }
    }
  }

  const toDisplay = document.querySelector(`[data-personalization-variant-id="${variantId}"]`);
  let itemTitle = null;
  if (toDisplay) {
    let variantValueInput = toDisplay.querySelector('[data-action="handle-personalization"]')
    itemTitle = toDisplay.getAttribute('data-personalization-for')
    if (variantValueInput && variantPersonalizationValues[itemTitle]) {
      variantValueInput.value = variantPersonalizationValues[itemTitle];
    }
    toDisplay.classList.remove('hidden');
    if (variantValueInput) variantValueInput.dispatchEvent(new Event('keyup'));
  };

  let existingValuesCount = 0;

  if (toDisplay) {
    const valuesWrapper = toDisplay.querySelector('.existing-values--wrapper')
    existingValuesCount = valuesWrapper ? valuesWrapper.querySelectorAll('.existing-value--row[data-in-cart]').length : 0;
  }
  for (const [key, value] of Object.entries(variantPersonalizationValues)) {
    if (key !== itemTitle) {
      existingValuesCount += 1;
    }
  }
  
  if (toDisplay) {
    toDisplay.querySelector('[data-action="clone-existing"]').classList.toggle('hidden', existingValuesCount === 0);
    const existingSelectionHtml = parseExistingValuesHtml(variantPersonalizationValues, toDisplay.closest('.product-info'), itemTitle, variantId);
    toDisplay.querySelector('.existing-values--wrapper').innerHTML = existingSelectionHtml
    toDisplay.querySelector('.existing-values--wrapper').querySelectorAll('[data-action="apply-current-value"]').forEach(button => {
      button.addEventListener('click', handleApplyExistingValue)
    })
  }
}

function handleBadgeVisibility(variantId) {
    const visible = document.querySelectorAll(`[data-badge-variant-id]:not(.hidden)`)
    if (visible.length > 0) {
        visible.forEach(badge => {
            badge.classList.add('hidden');
        })
    };

    const toDisplay = document.querySelectorAll(`[data-badge-variant-id="${variantId}"]`)
    toDisplay.forEach(badge => {
        badge.classList.remove('hidden');
    })
}

function handleBatchVisibility(variantId) {
    const visible = document.querySelectorAll(`[data-batch-variant-id]:not(.hidden)`)
    if (visible.length > 0) {
        visible.forEach(batch => {
            batch.classList.add('hidden');
        })
    };

    const toDisplay = document.querySelectorAll(`[data-batch-variant-id="${variantId}"]`)
    toDisplay.forEach(batch => {
        batch.classList.remove('hidden');
    })
}

/* Personalization functionality */

function parseExistingValuesHtml(variantPersonalizationValues, form, itemTitle, variantId) {
  const variantSet = form.querySelector(`[data-personalization-variant-id="${variantId}"]`)
  const existingOptions = variantSet.querySelectorAll('.existing-value--row')

  let html = '';

  existingOptions.forEach(option => {
    if (option.hasAttribute('data-in-cart')) {
      html += `<div class="existing-value--row" data-in-cart>${option.innerHTML}</div>`
    }
  })

  for (const [key, value] of Object.entries(variantPersonalizationValues)) {
    if (key !== itemTitle) {
      html += `<div class="existing-value--row">
        <div class="existing-value--key">${key.split(' (')[0]}</div>
        <div class="existing-value--value">
          ${value.replaceAll('\n', ', ')}
          <div></div>
          <button class="existing-value--apply" data-action="apply-current-value" data-value="${value.replaceAll('\n', '////')}">Select</button>
        </div>
      </div>`;
    }
  }
  return html;
  // <button class="existing-value--apply" onclick="handleApplyExistingValue('${key}', '${parent.getAttribute('data-product-id')}', '${variantId}')">Select</button>

}

function initVariantChangeHandler() {
  document.addEventListener('variant:change', (event) => {
    handleVariantChange(event);
  });
}

document.addEventListener('DOMContentLoaded', initVariantChangeHandler);

function handleAddToCart(event) {
  const propsInputs = document.querySelectorAll('[data-attributes-input], [data-action="handle-personalization"]');
  
  propsInputs.forEach(input => {
    if (input.getAttribute('data-action') === 'handle-personalization') {
      const parent = input.closest('[data-personalization-variant-id]');
      if (!parent.classList.contains('hidden')) {
        input.value = '';
        input.dispatchEvent(new Event('keyup'));
      } else if (input.getAttribute('data-attributes-input')) {
        input.value = '';
      }
    }
  })
}

document.addEventListener('cart:added', (event) => {
  handleAddToCart(event);
})

function checkTextSize(compareWidth, placeholder, value) {
  placeholder.innerHTML = `<p>${value}</p>`;

  const baseSize = window.matchMedia("(max-width: 767px)").matches ? 18.5 : 28;
  // Add mobile compaenstation?? 
  let fontSize = placeholder.clientWidth > compareWidth ? baseSize * (compareWidth / placeholder.clientWidth) : baseSize;
  fontSize += 'px'
  placeholder.innerHTML = '';        
  return fontSize;
}

function handlePersonalizeChange(parent, placeholder, input, event) {
  const value = event.target.value
  let values = value.split('\n')
  const grandparent = parent.closest('.product-info');
  values = values.filter(value => value.trim() !== '')
  const validatedValues = []

  const previews = parent.querySelectorAll('[data-content="preview-display"]:not([data-placeholder])');

  const firstPreview = parent.querySelector(`[data-content="preview-display"][data-display-index="0"]`);
  const textareaWidth = firstPreview.querySelector('[data-content="preview-text"]').offsetWidth;

  for (let i = 0; i < values.length; i++) {
      const originalValue = values[i]
      const value = originalValue.length > 12 ? originalValue.slice(0, 12) : originalValue
      const fontSize = checkTextSize(textareaWidth, placeholder.querySelector('[data-content="preview-text"]'), value);

      const preview = parent.querySelector(`[data-content="preview-display"][data-display-index="${i}"]`);
      if (preview) {
          const textHolder = preview.querySelector('[data-content="preview-text"]');
          textHolder.style.fontSize = fontSize;
          textHolder.textContent = value
      } else {
          const newPreview = placeholder.cloneNode(true);
          newPreview.removeAttribute('data-placeholder');
          newPreview.setAttribute('data-display-index', i);
          newPreview.classList.remove('hidden');
          newPreview.querySelector('[data-content="preview-text"]').textContent = value;
          const textHolder = newPreview.querySelector('[data-content="preview-text"]');
          textHolder.style.fontSize = fontSize;
          textHolder.textContent = value
          parent.querySelector('.personalize-scroller').insertBefore(newPreview, parent.querySelector('.personalize-scroller').firstChild);
      }
      validatedValues.push(value)
      if (originalValue !== value && i === values.length - 1) {
          input.value = validatedValues.join('\n');
      }
  }

  if (values.length === 0) {
      const preview = parent.querySelector(`[data-content="preview-display"][data-display-index="0"]`)
      preview.querySelector('[data-content="preview-text"]').textContent = "";
  }

  if (previews.length > values.length) {
      const difference = previews.length - values.length;
      for (let i = 0; i < difference; i++) {
          const removeIndex = previews.length - i - 1;
          if (removeIndex > 0) {
              parent.querySelector(`[data-content="preview-display"][data-display-index="${removeIndex}"]`).remove();
          }
      }
  }

  const quantity = values.length > 0 ? values.length : 1;
  const qtyInput = grandparent.querySelector('.quantity-selector__input');
  qtyInput.value = quantity;
  qtyInput.dispatchEvent(new Event('change'));

  const addToCartButton = grandparent.querySelector('button[type="submit"]');
  addToCartButton.disabled = values.length === 0;
  updateItemAttributes(grandparent, validatedValues)
}

function updateItemAttributes(form, values) {
  const attributesParent = getAttributesInput(form)
  if (!attributesParent) return;
  attributesParent.value = values.join('///');
}

function getAttributesInput(form) {
  const attributesParent = form.querySelector('[data-attributes-parent]')
  if (!attributesParent) return null;

  const attributesInput = attributesParent.querySelector('input[name="properties[Personalization names]"]')
  if (attributesInput) {
      return attributesInput;
  }
  const newInput = document.createElement('input');
  newInput.type = 'hidden';
  newInput.name = 'properties[Personalization names]';
  newInput.setAttribute('data-attributes-input', true);
  attributesParent.appendChild(newInput);
  return newInput;
}

function displayCloneOptions(event, parent) {
  const actionsPanel = parent.querySelector('.existing-values--wrapper')
  event.target.textContent = actionsPanel.getAttribute('data-active') === 'true' ? 'Fill with existing' : 'Cancel';
  actionsPanel.setAttribute('data-active', actionsPanel.getAttribute('data-active') === 'true' ? 'false' : 'true');
  parent.querySelector('.existing-values--wrapper').classList.toggle('hidden');
}

function handlePersonalizeFocus(event) {
  document.querySelectorAll('.existing-values--wrapper').forEach(wrapper => {
      wrapper.classList.add('hidden');
      wrapper.setAttribute('data-active', 'false');
  })
  document.querySelectorAll('[data-action="clone-existing"]').forEach(button => {
      button.textContent = 'Fill with existing'
  })
}

function initPersonalizationHandlers() {
  const personalizationInputs = document.querySelectorAll('textarea[data-action="handle-personalization"]');
  personalizationInputs.forEach(input => {
      const parent = input.closest('[data-personalization-for]');
      const placeholder = parent.querySelector('[data-content="preview-display"][data-placeholder]');
      input.addEventListener('keyup', function(event) {
          handlePersonalizeChange(parent, placeholder, input, event)
      })
      input.addEventListener('click', handlePersonalizeFocus)
      const cloneOptionsToggle = parent.querySelector('[data-action="clone-existing"]');
      cloneOptionsToggle.addEventListener('click', function(event) {
          displayCloneOptions(event, parent)
      })
      const applyClones = parent.querySelectorAll('[data-action="apply-current-value"]');
      applyClones.forEach(button => {
          button.addEventListener('click', handleApplyExistingValue)
      })
  })
}

function handleApplyExistingValue() {
  const newValue = this.getAttribute('data-value').replaceAll('////', '\n')
  const parent = this.closest('[data-personalization-for]')
  const input = parent.querySelector('textarea[data-action="handle-personalization"]')
  input.value = newValue
  input.dispatchEvent(new Event('keyup'))
  const wrapper = this.closest('.personalization-input--wrapper')
  wrapper.querySelector('[data-action="clone-existing"]').click()

}

document.addEventListener('DOMContentLoaded', initPersonalizationHandlers); 